import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


export const getBarangjasaFileContent = createAsyncThunk('/barangjasafile/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listGoodsServicesFile/${userId}`, {})
    return response.data;
})

export const barangjasafileSlice = createSlice({
    name: 'barangjasafile',
    initialState: {
        isLoading: false,
        barangjasafile: []
    },
    reducers: {


        addNewBarangjasaFile: (state, action) => {
            let { newBarangjasaFileObj } = action.payload
            state.barangjasafile = [...state.barangjasafile, newBarangjasaFileObj]
        }
    },

    /*extraReducers: {
        [getBarangjasaFileContent.pending]: state => {
            state.isLoading = true
        },
        [getBarangjasaFileContent.fulfilled]: (state, action) => {
            state.barangjasafile = action.payload.data
            state.isLoading = false
        },
        [getBarangjasaFileContent.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getBarangjasaFileContent.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getBarangjasaFileContent.fulfilled, (state, action) => {
            state.barangjasafile = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getBarangjasaFileContent.rejected, (state) => {
            state.isLoading = false;
          });
      },
})

export const { addNewBarangjasaFile } = barangjasafileSlice.actions

export default barangjasafileSlice.reducer